import { useTranslation } from 'react-i18next'

import type { ComplianceState } from './api'

/**
 * Compliance standing, as a chip. State reads from shape and text, never from colour
 * alone — a blocked carrier has to be obvious to someone who cannot tell red from green.
 */
export function ComplianceBadge({ state }: { state: ComplianceState }) {
  const { t } = useTranslation()

  return (
    <span className={`badge badge--${state.toLowerCase()}`}>
      {t(`compliance.${state.toLowerCase()}`)}
    </span>
  )
}
